var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFatture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.988 20.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-80 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(80 17.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M92.263,67.075H82.725A2.728,2.728,0,0,1,80,64.35V50.725A2.728,2.728,0,0,1,82.725,48h1.363v1.363H82.725a1.364,1.364,0,0,0-1.363,1.363V64.35a1.364,1.364,0,0,0,1.363,1.363h9.538a1.364,1.364,0,0,0,1.363-1.363V50.725a1.364,1.364,0,0,0-1.363-1.363H90.9V48h1.363a2.728,2.728,0,0,1,2.725,2.725V64.35A2.728,2.728,0,0,1,92.263,67.075Z",
    transform: "translate(-80 -48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(83.406 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M166.381,20.088h-4.587A1.8,1.8,0,0,1,160,18.294v-.5A1.8,1.8,0,0,1,161.794,16h4.587a1.8,1.8,0,0,1,1.794,1.794v.5A1.8,1.8,0,0,1,166.381,20.088Zm-4.587-2.725a.432.432,0,0,0-.431.431v.5a.432.432,0,0,0,.431.431h4.587a.432.432,0,0,0,.431-.431v-.5a.432.432,0,0,0-.431-.431Z",
    transform: "translate(-160 -16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFatture);
export default __webpack_public_path__ + "static/media/icn_fatture.7c7d42f5.svg";
export { ForwardRef as ReactComponent };